export type TodoType = 'CALL' | 'MEETING' | 'INTERNAL_TASK';
export type TimeType = 'DEADLINE' | 'EXACT_TIME' | 'INTERVAL';
export type CompletionType = 'EVERYONE' | 'ANYONE';
export type RecurringType = 'DAILY' | 'WEEKLY' | 'MONTHLY';

export const DAYS = Array.from({ length: 31 }, (_, i) => String(i + 1));
export const YEARS = Array.from({ length: 2 }, (_, i) => String(new Date().getFullYear() + i));

export const TIME_TYPE_MAP: Record<string, TimeType> = {
  deadline: 'DEADLINE',
  exact: 'EXACT_TIME',
  interval: 'INTERVAL',
};

export const COMPLETION_TYPE_MAP: Record<string, CompletionType> = {
  everyone: 'EVERYONE',
  anyone: 'ANYONE',
};

export const RECURRING_TYPES: RecurringType[] = ['DAILY', 'WEEKLY', 'MONTHLY'];

export const TODO_ID_QUERY_KEY = 'id';
